
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSearchBox } from 'react-instantsearch';

import { SearchResultsInfinite } from '@uncinc/react-searchkit';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchForumHit as Hit } from '../types';
import SearchForumHit from './Hit';

import './style.scss';

export interface SearchForumResultsProps {
  className?: string;
}

const SearchForumResults: React.FC<SearchForumResultsProps> = (props) => {
  const { className } = props;

  const { query } = useSearchBox();
  const { t } = useTranslation('translation', { keyPrefix: 'components.search_forum.results' });

  const classes = c('SearchForum__Results', className);

  // Only show stats if there's a search query.
  if (!query || query.trim() === '') {
    return null;
  }

  return (
    <div className={classes}>
      <Container>
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <SearchResultsInfinite
              className="SearchForum__Results__list"
              autoScroll
              showMoreButtonText={t('load_more')}
              renderItem={(hit) => <SearchForumHit hit={hit as Hit} />}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SearchForumResults;
